/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_InterviewInputs */

const en_nav_interview = /** @type {(inputs: Nav_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview Prep`)
};

const de_nav_interview = /** @type {(inputs: Nav_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview-Prep`)
};

const fr_nav_interview = /** @type {(inputs: Nav_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prépa entretien`)
};

const es_nav_interview = /** @type {(inputs: Nav_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prep entrevista`)
};

const it_nav_interview = /** @type {(inputs: Nav_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prep colloquio`)
};

const nl_nav_interview = /** @type {(inputs: Nav_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatieprep`)
};

const pl_nav_interview = /** @type {(inputs: Nav_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prep rozmowy`)
};

const fi_nav_interview = /** @type {(inputs: Nav_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haastatteluprep`)
};

const da_nav_interview = /** @type {(inputs: Nav_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviewprep`)
};

const sv_nav_interview = /** @type {(inputs: Nav_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervjuprep`)
};

/**
* | output |
* | --- |
* | "Interview Prep" |
*
* @param {Nav_InterviewInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_interview = /** @type {((inputs?: Nav_InterviewInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_InterviewInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_interview(inputs)
	if (locale === "fr") return fr_nav_interview(inputs)
	if (locale === "es") return es_nav_interview(inputs)
	if (locale === "it") return it_nav_interview(inputs)
	if (locale === "nl") return nl_nav_interview(inputs)
	if (locale === "pl") return pl_nav_interview(inputs)
	if (locale === "fi") return fi_nav_interview(inputs)
	if (locale === "da") return da_nav_interview(inputs)
	if (locale === "sv") return sv_nav_interview(inputs)
	return en_nav_interview(inputs)
});